// ==============================|| I18N - ENGLISH ||============================== //
// Mirrors the key set of ./es.js. A key missing here falls back to Spanish (see
// `translate`), so a partial translation degrades to readable text instead of
// showing a raw key.

const en = {
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'common.loading': 'Loading...',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.noPermission': 'You do not have permission to view this information.',
  'common.unexpectedError': 'An unexpected error occurred.',
  'common.all': 'All',
  'common.confirm': 'Confirm',

  'dashboard.title': 'Dashboard',
  'dashboard.totalRoutes': 'Total routes',
  'dashboard.totalWorkers': 'Total workers',
  'dashboard.totalBoxes': 'Active boxes',
  'dashboard.totalLoans': 'Loans',
  'dashboard.totalCollections': 'Collections',
  'dashboard.overview': 'Business overview',
  'dashboard.uniqueVisitor': 'Unique visitors',
  'dashboard.salesReport': 'Sales report',
  'dashboard.recentOrders': 'Recent orders',
  'dashboard.analyticsReport': 'Analytics report',

  'language.label': 'Language',
  'language.change': 'Change language',

  'routes.title': 'Routes',
  'routes.create': 'Create route',
  'routes.creating': 'Saving route...',
  'routes.edit': 'Edit route',
  'routes.backToList': 'Back to route list',
  'routes.id': 'Sequential ID',
  'routes.idHelp': 'Generated by the system when the route is created.',
  'routes.idPlaceholder': 'Assigned on save',
  'routes.name': 'Name',
  'routes.description': 'Description',
  'routes.number': 'Route number',
  'routes.country': 'Country',
  'routes.state': 'State / Department',
  'routes.city': 'City',
  'routes.currency': 'Currency',
  'routes.currencyUnavailable': 'The catalog does not report a currency for this country yet.',
  'routes.currencyFromCountry': 'The currency is determined by the selected country.',
  'routes.location': 'Location',
  'routes.initialValue': 'Initial value',
  'routes.maxSale': 'Maximum sale',
  'routes.expenses': 'Expenses',
  'routes.workingDays': 'Working days',
  'routes.frequency': 'Collection frequency',
  'routes.automaticOpening': 'Automatic cash drawer opening',
  'routes.automaticOpeningOn': 'The cash drawer will open automatically on the selected working days.',
  'routes.automaticOpeningNeedsDays': 'Select at least one working day to enable automatic opening.',
  'routes.cashOpening': 'Cash drawer opening',
  'routes.cashOpeningAutomatic': 'Automatic',
  'routes.cashOpeningManual': 'Manual',
  'routes.collector': 'Collector',
  'routes.collectorUnassigned': 'Unassigned',
  'routes.collectorManagedElsewhere': 'Worker assignment is managed from Worker management.',
  'routes.users': 'Users who can see the route',
  'routes.usersEmpty': 'This route has no authorized users.',
  'routes.usersHidden': 'This route has {{count}} authorized user(s).',
  'routes.usersSearch': 'Search user...',
  'routes.usersNotFound': 'User not found',
  'routes.usersLoadError': 'The user catalog could not be loaded',
  'routes.usersLoading': 'Loading users...',
  'routes.sectionInformation': 'Information',
  'routes.sectionPermissions': 'Permissions',
  'routes.sectionDaysAndFrequency': 'Working days and frequency',
  'routes.sectionCashAndCollection': 'Cash drawer and collection settings',
  'routes.clients': 'Route clients',
  'routes.clientsAdd': 'Add clients',
  'routes.clientsEmpty': 'This route has no clients assigned yet.',
  'routes.listEmpty': 'No routes match the filter.',
  'routes.allCollectors': 'All collectors',
  'routes.allStatuses': 'All statuses',
  'routes.created': 'Route "{{nombre}}" created successfully with sequential number {{consecutivo}}.',
  'routes.deactivate': 'Deactivate route',
  'routes.deactivateConfirm': 'Deactivate the route "{{nombre}}"?',
  'routes.deactivateAction': 'Deactivate',
  'routes.removeClient': 'Remove client from route',
  'routes.removeClientConfirm': 'Remove {{nombre}} from this route?',
  'routes.removeClientAction': 'Remove',
  'routes.removeClientTooltip': 'Remove from route',
  'routes.viewDetail': 'View detail',
  'routes.createError': 'The route could not be created.',
  'routes.createForbidden': 'You do not have permission to create routes.',
  'routes.updateForbidden': 'You do not have permission to edit routes.',
  'routes.updateError': 'The route could not be saved.',

  'routes.validation.name': 'Name is required',
  'routes.validation.number': 'Route number is required and must be numeric',
  'routes.validation.initialValue': 'Initial value is required and must be numeric',
  'routes.validation.users': 'Select at least one user who can see the route',
  'routes.validation.country': 'Country is required',
  'routes.validation.state': 'State / department is required',
  'routes.validation.city': 'City is required',
  'routes.validation.maxSale': 'Maximum sale is required and must be numeric',
  'routes.validation.expenses': 'Expenses value is required and must be numeric',
  'routes.validation.workingDays': 'Select at least one working day',
  'routes.validation.automaticOpening': 'Automatic cash drawer opening requires at least one working day',
  'routes.validation.frequency': 'Collection frequency is required',

  'routes.edit.lockedBySales': 'It cannot be changed because the route already has registered sales.',
  'routes.edit.lockedByContract': 'This field cannot be changed from this screen yet.',
  'routes.edit.lockedNotice': 'Disabled fields keep their current value: they are shown for reference and are not sent on save.',

  'location.selectCountry': 'Select a country',
  'location.selectState': 'Select a state / department',
  'location.selectCity': 'Select a city',
  'location.selectCountryFirst': 'Select a country first',
  'location.selectStateFirst': 'Select a state / department first',
  'location.loadingCountries': 'Loading countries...',
  'location.loadingStates': 'Loading states...',
  'location.loadingCities': 'Loading cities...',
  'location.countriesError': 'The country list could not be loaded.',
  'location.statesError': 'The state list could not be loaded.',
  'location.citiesError': 'The city list could not be loaded.',
  'location.countriesEmpty': 'The country catalog is empty.',
  'location.statesEmpty': 'This country has no states loaded yet.',
  'location.citiesEmpty': 'This state has no cities loaded yet.',

  'cash.title': 'Cash drawer',
  'cash.name': 'Cash drawer',
  'cash.businessDate': 'Business date',
  'cash.openingDate': 'Opening date',
  'cash.route': 'Route',
  'cash.worker': 'Worker',
  'cash.selectRoute': 'Select a route',
  'cash.selectRouteFirst': 'Select a route to see its cash drawers.',
  'cash.empty': 'There are no cash drawers for this route.',
  'cash.open': 'Open new cash drawer',
  'cash.openAction': 'Open cash drawer',
  'cash.initialAmount': 'Initial amount',
  'cash.initialAmountCarryOver': "It's the closing balance of this route's last cash register.",
  'cash.initialAmountRouteDefault': "It's the route's configured initial amount: it hasn't had a cash register yet.",
  'cash.columnInitialAmount': 'Initial amount',
  'cash.columnClosingAmount': 'Closing amount',
  'cash.noWorker': 'This route has no collector assigned: a cash register cannot be opened without knowing for whom.',
  'cash.incident': 'Incident',
  'cash.statusOpen': 'Open',
  'cash.statusClosed': 'Closed',
  'cash.statusForceClosed': 'Force-closed',
  'cash.statusUnknown': 'Unknown',
  'cash.operations': 'Available operations',
  'cash.forceClose': 'Close cash drawer with a forced close',
  'cash.forceCloseDescription': 'This cash drawer will be force-closed. There may be unsynchronized movements.',
  'cash.forceCloseConfirm': 'Close cash drawer',
  'cash.reopen': 'Reopen cash drawer',
  'cash.reopenDescription': 'Reopen this force-closed cash drawer?',
  'cash.showMore': 'Show more cash drawers',

  'installments.mark': 'Mark installment',
  'installments.markShort': 'Mark',
  'installments.markTitle': 'Mark installment {{numero}}',
  'installments.client': 'Client',
  'installments.number': 'Installment',
  'installments.dueDate': 'Due date',
  'installments.amount': 'Installment amount',
  'installments.pending': 'Outstanding balance',
  'installments.pendingShort': 'Outstanding',
  'installments.amountToRegister': 'Amount to register',
  'installments.paymentMethod': 'Payment method',
  'installments.notes': 'Notes (optional)',
  'installments.confirmTitle': 'Confirm installment marking',
  'installments.confirmDescription':
    'A payment of {{monto}} will be registered against this installment. This affects the loan balance and cannot be undone.',
  'installments.marking': 'Marking installment...',
  'installments.marked': 'Installment marked successfully.',
  'installments.error': 'The installment could not be marked.',
  'installments.alreadyPaid': 'This installment is already paid.',
  'installments.invalidAmount': 'Enter an amount greater than zero and no larger than the outstanding balance.',
  'installments.loanNotActive': 'Only installments of active loans can be marked.',

  'days.LUNES': 'Monday',
  'days.MARTES': 'Tuesday',
  'days.MIERCOLES': 'Wednesday',
  'days.JUEVES': 'Thursday',
  'days.VIERNES': 'Friday',
  'days.SABADO': 'Saturday',
  'days.DOMINGO': 'Sunday',

  'frequency.DIARIA': 'Daily',
  'frequency.SEMANAL': 'Weekly',
  'frequency.QUINCENAL': 'Biweekly',
  'frequency.MENSUAL': 'Monthly',

  'routes.maxSaleHelp':
    'Enter the maximum sale amount allowed for the route. Above this amount, approval from the route administrator/coordinator is requested.',
  'routes.expensesHelp':
    'Enter the maximum expense amount allowed for the route. Above this amount, approval from the route administrator/coordinator is requested.',

  // Platform billing to units (PROP-002). These strings describe what the screen
  // will show and what is still undefined: none of them states a rule, a price,
  // a billing period or a concrete status, because none of that is defined yet.
  'platform.title': 'Platform billing',
  'platform.description':
    'Billing for each unit’s use of the platform. This is separate from the operational debt collection charged to route clients.',
  'platform.pendingNotice':
    'Module pending business definition (PROP-002). The screen is scaffolded but shows no data: the rules are not defined yet and the backend does not expose the corresponding services.',
  'platform.pendingValue': 'Pending definition',
  'platform.unit': 'Unit',
  'platform.sectionUnitBilling': 'Unit billing configuration',
  'platform.sectionPeriodicity': 'Billing frequency',
  'platform.sectionPlan': 'Assigned plan / price',
  'platform.sectionBillingStatus': 'Billing and payment status',
  'platform.sectionUnitStatus': 'Unit status',
  'platform.sectionBillingContact': 'Billing contact',
  'platform.sectionPaymentMethod': 'Payment method',
  'platform.openQuestionsTitle': 'Pending definitions (PROP-002)',
  'platform.openQuestionsIntro': 'These are business/commercial decisions. Until they are made, this module’s rules are not built.',
  'platform.question1': 'Billing frequency: how often each unit is billed, and whether it is the same for all units.',
  'platform.question2': 'User limit per unit, and whether the price depends on that number or is a fixed value per unit.',
  'platform.question3':
    'Blocking on non-payment: after how many days overdue, whether it is total or partial, and how it is reactivated after payment.',
  'platform.question4': 'Payment reminders: how far in advance, through which channel, and how many are sent before blocking.',
  'platform.question5': 'What happens to the data and the portfolio of a unit blocked for non-payment.',
  'platform.question6': 'Who receives the invoice on the unit’s side (role or contact responsible for payment).',
  'platform.question7': 'Payment method for the service.',

  // Worker management (US-006 create, US-007 devices, US-008 list).
  'workers.moduleTitle': 'Worker management',
  'workers.tabCreate': 'Create new worker',
  'workers.tabList': 'Workers',
  'workers.tabDevices': 'Link devices',
  'workers.noTabs': 'You do not have permission for any option in this module.',

  'workers.searchPlaceholder': 'Search by name, nickname, document, phone...',
  'workers.allStatuses': 'All statuses',
  'workers.statusActive': 'Active',
  'workers.statusInactive': 'Inactive',
  'workers.columnPin': 'PIN',
  'workers.columnFullName': 'Full name',
  'workers.columnNickname': 'Nickname',
  'workers.columnPhone': 'Phone',
  'workers.columnUnit': 'Unit',
  'workers.pinNeverLinked': '\u2014 not linked \u2014',
  'workers.listEmpty': 'No workers match the search.',
  'workers.openActions': 'Worker actions',
  'workers.actionActivate': 'Activate',
  'workers.actionDeactivate': 'Deactivate',
  'workers.actionChangePassword': 'Change password',
  'workers.deactivateTitle': 'Confirm deactivation',
  'workers.deactivateConfirm': 'Deactivate {{nombre}}? This frees their unit and unlinks their device.',
  'workers.activateError': 'The worker could not be activated.',
  'workers.deactivateError': 'The worker could not be deactivated.',

  'workers.createTitle': 'Create new worker',
  'workers.editTitle': 'Edit worker',
  'workers.sectionUnit': 'Unit',
  'workers.unit': 'Unit',
  'workers.unitHelp': 'Only units with no worker assigned and belonging to your profile.',
  'workers.selectUnit': 'Select a unit',
  'workers.unitsEmpty': 'There are no units available to assign.',
  'workers.sectionPersonal': 'Personal data',
  'workers.firstName': 'First name',
  'workers.secondName': 'Middle name',
  'workers.firstSurname': 'First surname',
  'workers.secondSurname': 'Second surname',
  'workers.nickname': 'Nickname',
  'workers.sectionOrigin': 'Origin and identification',
  'workers.birthCountry': 'Country of birth',
  'workers.birthState': 'State of birth',
  'workers.birthCity': 'City of birth',
  'workers.documentType': 'Document type',
  'workers.selectDocumentType': 'Select a document type',
  'workers.documentTypeHelp': 'The list depends on the country of birth and includes passport.',
  'workers.documentTypeNeedsCountry': 'Select the country of birth first',
  'workers.document': 'Document',
  'workers.documentHelp': 'Unique; validation depends on the selected type.',
  'workers.sectionContact': 'Contact',
  'workers.email': 'Main email',
  'workers.phone': 'Main mobile number',
  'workers.phoneAdditional': 'Additional phone',
  'workers.addPhone': 'Add another phone',
  'workers.removePhone': 'Remove phone',
  'workers.sectionResidence': 'Residence',
  'workers.residenceCountry': 'Country of residence',
  'workers.residenceState': 'State of residence',
  'workers.residenceCity': 'City of residence',
  'workers.address': 'Main address',
  'workers.addressAdditional': 'Additional address',
  'workers.addAddress': 'Add another address',
  'workers.removeAddress': 'Remove address',
  'workers.sectionAccess': 'Access',
  'workers.password': 'Password',
  'workers.passwordHelp': 'The worker signs in with this password. Minimum 8 characters.',
  'workers.passwordConfirm': 'Confirm password',
  'workers.sectionAttachments': 'Attachments',
  'workers.attachmentsField': 'Select file',
  'workers.attachmentsHelp': 'Here you can attach the identity document details and a photo of the worker',
  'workers.attachmentsFormats': 'Optional. Images (JPG/PNG) and PDF.',
  'workers.attachmentsInvalidFile': 'Invalid file. Use JPG, PNG or PDF.',
  'workers.removeAttachment': 'Remove attachment',
  'workers.chooseFiles': 'Choose files',
  'workers.noFileSelected': 'No file selected',
  'workers.createError': 'The worker could not be created.',
  'workers.updateError': 'The worker could not be saved.',
  'workers.created': 'Worker created and linked to the unit.',
  'workers.updated': 'Worker updated.',

  'workers.validation.unit': 'Unit is required',
  'workers.validation.firstName': 'First name is required',
  'workers.validation.firstSurname': 'First surname is required',
  'workers.validation.nickname': 'Nickname is required',
  'workers.validation.documentType': 'Document type is required',
  'workers.validation.document': 'Document is required',
  'workers.validation.documentFormat': 'The document does not match the format for the selected document type',
  'workers.validation.email': 'Enter a valid email address',
  'workers.validation.phone': 'The main mobile number is required',
  'workers.validation.residenceCountry': 'Country of residence is required',
  'workers.validation.residenceState': 'State of residence is required',
  'workers.validation.residenceCity': 'City of residence is required',
  'workers.validation.address': 'The main address is required',
  'workers.validation.password': 'The password must be at least 8 characters',
  'workers.validation.passwordConfirm': 'Passwords do not match',

  'workers.devicesStep1': 'Step 1 \u00b7 Select the unit',
  'workers.devicesUnitHelp': 'On selection, the device of the unit is shown or linking one is enabled.',
  'workers.devicesSelectUnitFirst': 'Select a unit to continue.',
  'workers.deviceCaseA': 'This unit already has a linked device',
  'workers.deviceCaseB': 'This unit has no linked device',
  'workers.deviceWorker': 'Worker',
  'workers.devicePin': 'Device PIN',
  'workers.deviceStatus': 'Status',
  'workers.deviceLinkedAt': 'Linked on',
  'workers.deviceLinked': 'Linked',
  'workers.unlinkReason': 'Unlink reason',
  'workers.selectReason': 'Select a reason',
  'workers.reasonUnitChange': 'Unit change',
  'workers.reasonDeactivated': 'Deactivated',
  'workers.reasonLostStolen': 'Device lost or stolen',
  'workers.unlink': 'Unlink',
  'workers.unlinkTwoSteps': 'Select the reason (required) and press Unlink; then confirm in the dialog.',
  'workers.unlinkConfirmTitle': 'Confirm unlinking',
  'workers.unlinkConfirm': 'Unlink the device of {{nombre}}?',
  'workers.unlinkReasonLine': 'Reason: {{motivo}}',
  'workers.unlinkError': 'The device could not be unlinked.',
  'workers.link': 'Link',
  'workers.enterPin': 'Enter the PIN of the device of the worker',
  'workers.pinHelp': 'The 6-digit PIN is generated by the system and shown in the worker app when they sign in from their phone.',
  'workers.linkError': 'The device could not be linked.',
  'workers.linked': 'Device linked.',
  'workers.unlinked': 'Device unlinked.',

  // Activity log (US-009). "Logs" is the module's technical name; the
  // user-facing name is "Activity log".
  'activityLog.title': 'Activity log',
  'activityLog.unit': 'Unit',
  'activityLog.selectUnit': 'Select a unit',
  'activityLog.noUnits': 'You have no units linked to your profile.',
  'activityLog.dateFrom': 'Date from',
  'activityLog.dateTo': 'Date to',
  'activityLog.search': 'Search',
  'activityLog.invalidRange': 'The start date cannot be after the end date.',
  'activityLog.emptyState': 'Select a unit and a date range to query the activity log.',
  'activityLog.noResults': 'No records found for the selected filters.',
  'activityLog.columnDate': 'Date and time',
  'activityLog.columnUser': 'User',
  'activityLog.columnOrigin': 'Origin',
  'activityLog.columnUnit': 'Unit',
  'activityLog.columnModule': 'Module',
  'activityLog.columnEntity': 'Affected entity',
  'activityLog.columnProcess': 'Process',
  'activityLog.columnDetail': 'Detail',
  'activityLog.columnBefore': 'Previous value',
  'activityLog.columnAfter': 'New value',
  'activityLog.noValue': '—',
  'activityLog.filterUser': 'Filter by user',
  'activityLog.filterOriginAll': 'All origins',
  'activityLog.filterModuleAll': 'All modules',
  'activityLog.filterProcessAll': 'All processes',
  'activityLog.filterEntity': 'Filter by entity',
  'activityLog.filterDetail': 'Filter by detail',
  'activityLog.clearFilters': 'Clear filters',
  'activityLog.exportExcel': 'Download Excel',
  'activityLog.exporting': 'Downloading...',
  'activityLog.originWeb': 'Web',
  'activityLog.originMobile': 'Mobile',
  'activityLog.moduleCaja': 'Cash register',
  'activityLog.moduleTrabajadores': 'Workers',
  'activityLog.moduleDispositivos': 'Devices',
  'activityLog.moduleVentas': 'Sales',
  'activityLog.modulePagos': 'Payments',
  'activityLog.moduleGastos': 'Expenses',
  'activityLog.moduleIngresos': 'Income',
  'activityLog.moduleClientes': 'Clients',
  'activityLog.moduleRutas': 'Routes',
  'activityLog.moduleCargueCartera': 'Portfolio upload',
  'activityLog.processCreation': 'Creation',
  'activityLog.processModification': 'Modification',
  'activityLog.processDeletion': 'Deletion',
  'cash.uploadPortfolio': 'Upload portfolio',
  'cartera.title': 'Upload portfolio',
  'cartera.route': 'Route',
  'cartera.back': 'Back to cash drawers',
  'cartera.intro': "Bulk-load this route's portfolio from the template. Loaded clients are linked to the route.",
  'cartera.notCashNotice': 'Loading portfolio records receivables: it is not money received and does not change cash values.',
  'cartera.stepTemplate': 'Step 1 · Download the template',
  'cartera.stepFile': 'Step 2 · Select the completed template',
  'cartera.stepRun': 'Step 3 · Run the load',
  'cartera.fieldsTitle': 'Template fields',
  'cartera.fieldsHelp': 'Fields marked with * are required.',
  'cartera.frequenciesHelp': 'Allowed frequencies: {{frecuencias}}. The first installment date uses the dd/mm/yyyy format.',
  'cartera.requiredField': 'required',
  'cartera.downloadTemplate': 'Download template',
  'cartera.downloading': 'Downloading...',
  'cartera.downloadError': 'The template could not be downloaded.',
  'cartera.fileInputLabel': 'Completed template (.xlsx)',
  'cartera.selectFile': 'Select file',
  'cartera.replaceFile': 'Replace file',
  'cartera.removeFile': 'Remove file',
  'cartera.noFile': 'No file selected',
  'cartera.fileReady': 'Ready to load',
  'cartera.fileInvalidExtension': 'The file must be an Excel template (.xlsx).',
  'cartera.fileEmpty': 'The file is empty.',
  'cartera.fileTooLarge': 'The file exceeds the maximum allowed size.',
  'cartera.execute': 'Run load',
  'cartera.validate': 'Validate file',
  'cartera.selectFirst': 'Select a file to continue.',
  'cartera.processing': 'Processing the load. Do not close or reload this page.',
  'cartera.validating': 'Validating the file...',
  'cartera.successTitle': 'Portfolio loaded successfully',
  'cartera.successDetail':
    '{{clientes}} clients were loaded with their portfolio ({{cuotas}} installments). Total receivable balance: {{saldo}}.',
  'cartera.validTitle': 'The file is valid',
  'cartera.validDetail':
    'No errors were found. Running the load will create {{clientes}} clients with {{cuotas}} installments and a receivable balance of {{saldo}}. Nothing has been loaded yet.',
  'cartera.loadAnother': 'Load another file',
  'cartera.rejectedTitle': 'File rejected: no records were loaded',
  'cartera.rejectedDetail':
    'Found {{errores}} errors in the {{filas}} rows read. The load is all-or-nothing: while any error exists no client is loaded. Fix the file in Excel and select it again.',
  'cartera.colRow': 'Row',
  'cartera.colField': 'Field',
  'cartera.colDescription': 'Description',
  'cartera.fileLevel': 'File',
  'cartera.unexpectedError': 'The operation could not be completed',
  'cartera.unexpectedErrorDetail': 'An unexpected error occurred.',
  'cartera.canRetry': 'No records were loaded. You can try again.',
  'cartera.noPermission': 'You do not have permission to upload portfolio.',
  'cartera.routeNotFound': 'The route does not exist or is not linked to your profile.',
  'profiles.pageTitle': 'Roles and permissions',
  'profiles.tabsLabel': 'Profiles',
  'profiles.tabNew': 'New Profile',
  'profiles.tabList': 'Profile List',
  'profiles.name': 'Profile name',
  'profiles.namePlaceholder': 'E.g. Supervisor',
  'profiles.nameRequired': 'The profile name is required',
  'profiles.nameMin': 'The name must have at least 3 characters',
  'profiles.status': 'Status',
  'profiles.statusActive': 'Active',
  'profiles.statusInactive': 'Inactive',
  'profiles.import': 'Import a profile?',
  'profiles.importSelect': 'Existing profiles',
  'profiles.importPlaceholder': 'Select a profile',
  'profiles.importLoading': 'Loading profiles…',
  'profiles.importEmpty': 'There are no profiles to import yet.',
  'profiles.importError': 'The existing profiles could not be loaded.',
  'profiles.importLoaded': 'Permissions loaded from the profile «{{nombre}}». You can change them before saving.',
  'profiles.importKept': '{{cantidad}} permissions of «{{nombre}}» that this table does not break down yet will be kept when saving.',
  'profiles.permissionsTitle': 'Profile permissions',
  'profiles.permissionsHelp':
    'Define what this profile will be able to do. These are the permissions of the profile you are creating, not yours.',
  'profiles.loadingPermissions': 'Loading permissions…',
  'profiles.permissionsError': 'The permission catalog could not be loaded.',
  'profiles.retry': 'Retry',
  'profiles.save': 'Save Profile',
  'profiles.saving': 'Saving…',
  'profiles.saved': 'Profile «{{nombre}}» created successfully.',
  'profiles.saveError': 'The profile could not be saved.',
  'profiles.colPermission': 'Permission',
  'profiles.tableLabel': 'Permissions by module',
  'profiles.level.none': 'None',
  'profiles.level.read': 'Read',
  'profiles.level.full': 'Full',
  'profiles.level.noneHelp': 'no access to the module or the action.',
  'profiles.level.readHelp': 'can view the module information, without changing it.',
  'profiles.level.fullHelp': 'full access to the module, or can run the action.',
  'profiles.legendTitle': 'Meaning of the levels',
  'profiles.legendActions': 'Actions are specific operations: they are either allowed (Full) or not (None).',
  'profiles.kind.module': 'Module',
  'profiles.kind.action': 'Action',
  'profiles.onlyActions': 'Actions only',
  'profiles.unavailable': 'Not available',
  'profiles.unavailableHelp': 'The server does not have this permission yet, so it cannot be assigned.',
  'profiles.module.dashboard': 'Dashboard',
  'profiles.module.rutas': 'Routes',
  'profiles.module.trabajadores': 'Worker management',
  'profiles.module.caja': 'Cash box',
  'profiles.module.cartera': 'Portfolio upload',
  'profiles.module.logs': 'Activity log (Logs)',
  'profiles.module.roles': 'Roles and permissions',
  'profiles.module.usuarios': 'Users',
  'profiles.action.rutas.crear': 'Create route',
  'profiles.action.rutas.editar': 'Edit route',
  'profiles.action.trabajadores.crear': 'Create worker',
  'profiles.action.trabajadores.dispositivos': 'Link / unlink devices',
  'profiles.action.caja.abrir': 'Open cash box',
  'profiles.action.caja.cerrar': 'Close cash box',
  'profiles.action.caja.cierre-forzado': 'Forced close',
  'profiles.action.caja.reabrir': 'Reopen cash box',
  'profiles.action.caja.operar': 'Confirm cash box, record expense and record income',
  'profiles.action.cartera.subir': 'Upload portfolio',
  'profiles.list.error': 'The profile list could not be loaded.',
  'cartera.selectRoute': 'Select a route',
  'cartera.selectRouteFirst': 'Select the route the portfolio will be loaded into.',
  'workers.alertsTitle': 'Pending link requests',
  'workers.alertPending': '{{nombre}} ({{unidad}}) signed in from {{equipo}} and is waiting for the PIN to be authorized.',
  'workers.alertDeviceChange':
    'Alert! {{nombre}} ({{unidad}}) signed in from a different device: {{equipo}}. {{anterior}} was automatically unlinked. Ask for the PIN shown in their app to link the new one.',
  'workers.alertAttend': 'Handle',
  'workers.pendingForUnit': '{{nombre}} is waiting to link {{equipo}}. Ask for the 6-digit PIN shown in their app.',
  'workers.noPendingForUnit': 'The worker has not signed in from their phone yet: the PIN is generated at that moment.',
  'workers.deviceModel': 'Device',
  'workers.deviceUnknown': 'Unidentified device',
  'clients.moduleTitle': 'Clients',
  'clients.tabNew': 'New Client',
  'clients.tabList': 'Client List',
  'clients.newTitle': 'New client',
  'clients.editTitle': 'Edit client',
  'clients.statusEditHint': 'The status is changed from the list, with confirmation.',
  'clients.requiredHint': 'Fields marked with * are required.',
  'clients.route': 'Route',
  'clients.routePlaceholder': 'Select route',
  'clients.routeHelp': 'The route determines the country, document types and cities.',
  'clients.country': 'Route country: {{pais}}',
  'clients.selectRouteFirst': 'Select a route first',
  'clients.city': 'City',
  'clients.cityPlaceholder': 'Search and select the city',
  'clients.cityNoOptions': 'No matching cities',
  'clients.firstName': 'First name',
  'clients.lastName': 'Last name',
  'clients.nickname': 'Nickname',
  'clients.email': 'Email',
  'clients.documentType': 'Document type',
  'clients.documentTypePlaceholder': 'Select the type',
  'clients.documentNumber': 'Document number',
  'clients.birthDate': 'Date of birth',
  'clients.address': 'Address',
  'clients.neighborhood': 'Neighborhood',
  'clients.phone': 'Mobile phone',
  'clients.phone2': 'Mobile phone 2',
  'clients.comment': 'Comment',
  'clients.activity': 'Economic activity',
  'clients.activityNone': 'No activity',
  'clients.activityEmpty': 'There are no economic activities available yet.',
  'clients.retry': 'Retry',
  'clients.catalogsError': 'The route options could not be loaded.',
  'clients.routesError': 'Your routes could not be loaded.',
  'clients.noRoutes': 'Your profile has no linked routes: there are no clients to manage.',
  'clients.loadingClient': 'Loading client…',
  'clients.clientNotFound': 'The client does not exist or is not in your profile.',
  'clients.backToList': 'Back to the list',
  'clients.created': 'Client «{{nombre}}» created successfully.',
  'clients.updated': 'Client «{{nombre}}» updated successfully.',
  'clients.saveError': 'The client could not be saved.',
  'clients.validation.route': 'The route is required',
  'clients.validation.firstName': 'The first name is required',
  'clients.validation.lastName': 'The last name is required',
  'clients.validation.nickname': 'The nickname is required',
  'clients.validation.emailFormat': 'The email format is not valid',
  'clients.validation.documentType': 'The document type is required',
  'clients.validation.documentNumber': 'The document number is required',
  'clients.validation.documentFormat': 'The document number does not match the format of the chosen type',
  'clients.validation.birthDateFuture': 'The date of birth cannot be in the future',
  'clients.validation.address': 'The address is required',
  'clients.validation.city': 'The city is required',
  'clients.validation.phone': 'The mobile phone is required',
  'clients.validation.phoneFormat': 'The phone number is not valid',
  'clients.validation.commentMax': 'The comment allows up to 500 characters',
  'clients.searchPlaceholder': 'Search by document, first name, last name or nickname',
  'clients.search': 'Search',
  'clients.allRoutes': 'View all routes',
  'clients.selectRouteOrAll': 'Select a route or check «View all routes».',
  'clients.columnRoute': 'Route',
  'clients.columnClient': 'Client',
  'clients.columnEmail': 'Email',
  'clients.columnDocument': 'Document number',
  'clients.columnOptions': 'Options',
  'clients.listEmpty': 'No clients match the filter.',
  'clients.toggleStatus': 'Change status of {{nombre}}',
  'clients.statusConfirmTitle': 'Change client status',
  'clients.statusConfirm': 'Do you want to change the status of client {{nombre}}? Their history will be kept.',
  'clients.statusConfirmNew': 'It will become {{estado}}.',
  'clients.statusConfirmAction': 'Change status',
  'clients.statusChanged': 'The status of «{{nombre}}» is now {{estado}}.',
  'clients.statusError': 'The client status could not be changed.',
  'profiles.module.clientes': 'Clients',
  'profiles.list.searchPlaceholder': 'E.g. Name',
  'profiles.list.search': 'Search',
  'profiles.list.showActive': 'Show active',
  'profiles.list.showInactive': 'Show inactive',
  'profiles.list.noStatusSelected': 'Check «Show active» or «Show inactive» to see profiles.',
  'profiles.list.colEdit': 'Edit',
  'profiles.list.colCode': 'Code',
  'profiles.list.colName': 'Name',
  'profiles.list.colUsers': 'Users',
  'profiles.list.colStatus': 'Status',
  'profiles.list.edit': 'Edit profile',
  'profiles.list.editProfile': 'Edit the profile {{nombre}}',
  'profiles.list.statusOf': 'Status of {{nombre}}: {{estado}}',
  'profiles.list.statusVisualHint': 'Visual only: the status is changed when editing the profile.',
  'profiles.list.showing': 'Showing {{desde}} to {{hasta}} of {{total}} records',
  'profiles.list.pagination': 'Profile pagination',
  'profiles.list.legend':
    'The Status toggle is visual only. The status is changed in Edit, with confirmation. A profile with assigned users cannot be deactivated.',
  'profiles.list.empty': 'No profiles match the search.',
  'profiles.editTitle': 'Edit profile',
  'profiles.statusOfProfile': 'Profile status',
  'profiles.cannotDeactivate':
    'This profile cannot be deactivated: it has {{cantidad}} assigned users. Reassign them to another profile before deactivating it.',
  'profiles.cannotDeactivateOne':
    'This profile cannot be deactivated: it has 1 assigned user. Reassign them to another profile before deactivating it.',
  'profiles.usersAssigned': '{{cantidad}} users have this profile.',
  'profiles.usersAssignedOne': '1 user has this profile.',
  'profiles.confirmStatusTitle': 'Confirm status change',
  'profiles.confirmDeactivate': 'Do you want to deactivate the profile «{{nombre}}»? It cannot be assigned to users while inactive.',
  'profiles.confirmActivate': 'Do you want to activate the profile «{{nombre}}»?',
  'profiles.confirmStatusAction': 'Change status',
  'profiles.updated': 'Profile «{{nombre}}» updated successfully.',
  'profiles.loadingProfile': 'Loading profile…',
  'profiles.profileNotFound': 'The profile does not exist.',
  'profiles.backToList': 'Back to the list',
  'lockouts.pageTitle': 'Mobile app lockouts',
  'lockouts.subtitle':
    'Workers whose app is locked. Only a lockout caused by failed attempts needs an administrator to release it; the others are released by the worker with their password.',
  'lockouts.searchPlaceholder': 'Search by worker or device',
  'lockouts.filterStatus': 'Lockout status',
  'lockouts.filterCause': 'Cause',
  'lockouts.allCauses': 'All causes',
  'lockouts.showAll': 'Also show those the worker releases',
  'lockouts.showAllHint':
    'These lockouts (inactivity, phone lock, manual) are released by the worker with their password: they are informational only.',
  'lockouts.empty': 'There are no lockouts to show.',
  'lockouts.loadError': 'The lockouts could not be loaded.',
  'lockouts.deviceUnknown': 'Unidentified device',
  'lockouts.column.worker': 'Worker',
  'lockouts.column.route': 'Route',
  'lockouts.column.blockedAt': 'Locked at',
  'lockouts.column.cause': 'Cause',
  'lockouts.column.device': 'Model / device',
  'lockouts.column.location': 'GPS location',
  'lockouts.column.attempts': 'Attempt history',
  'lockouts.column.status': 'Status',
  'lockouts.cause.INACTIVIDAD': 'Inactivity',
  'lockouts.cause.BLOQUEO_SO': 'Phone lock',
  'lockouts.cause.INTENTOS_FALLIDOS': 'Failed attempts',
  'lockouts.cause.MANUAL': 'Manual lock',
  'lockouts.state.BLOQUEADO': 'Locked',
  'lockouts.state.DESBLOQUEADO': 'Unlocked',
  'lockouts.state.codeIssued': 'Code issued (expires {{hora}})',
  'lockouts.method.CLAVE_PROPIA': 'Worker password',
  'lockouts.method.ADMIN_SENAL': 'Administrator signal',
  'lockouts.method.ADMIN_OTP': 'One-time code',
  'lockouts.method.ADMIN_CLAVE_RESTABLECIDA': 'Password reset by the administrator',
  'lockouts.gps.SIN_PERMISO': 'No location permission',
  'lockouts.gps.NO_DISPONIBLE': 'Location unavailable',
  'lockouts.gps.TIMEOUT': 'Not obtained in time',
  'lockouts.gps.OK': 'No coordinates',
  'lockouts.location.viewMap': 'View in Google Maps',
  'lockouts.location.accuracy': 'Accuracy ±{{m}} m',
  'lockouts.location.capturedAt': 'Taken on {{fecha}}',
  'lockouts.attemptsCount': '{{n}} attempts',
  'lockouts.viewHistoryOf': 'View attempt history of {{nombre}}',
  'lockouts.unlockDevice': 'Unlock device',
  'lockouts.unlockDeviceOf': 'Unlock the device of {{nombre}}',
  'lockouts.detail.title': 'Lockout detail',
  'lockouts.detail.attemptsTitle': 'Attempt history',
  'lockouts.detail.noAttempts': 'No failed attempts were recorded.',
  'lockouts.detail.attempt': 'Attempt {{n}}',
  'lockouts.detail.deviceClock': 'Device time',
  'lockouts.detail.serverClock': 'Server time',
  'lockouts.detail.authorizationTitle': 'Unlock authorization',
  'lockouts.detail.authorizedBy': 'Authorized by',
  'lockouts.detail.authorizedAt': 'Authorization date',
  'lockouts.detail.reason': 'Reason',
  'lockouts.detail.signature': 'Verification signature',
  'lockouts.detail.method': 'Unlocked through',
  'lockouts.unlock.title': 'Unlock device',
  'lockouts.unlock.intro': 'You are about to authorize unlocking the app of {{nombre}}. Confirm your identity with your password.',
  'lockouts.unlock.password': 'Your password',
  'lockouts.unlock.passwordHelp': 'Security check: it is not stored.',
  'lockouts.unlock.passwordRequired': 'Enter your password to authorize',
  'lockouts.unlock.mode': 'How the authorization reaches the worker',
  'lockouts.unlock.modeSignal': 'Signal to the app: it unlocks itself within seconds',
  'lockouts.unlock.modeCode': 'One-time code: I dictate it to the worker',
  'lockouts.unlock.reason': 'Reason for unlocking',
  'lockouts.unlock.reasonRequired': 'The reason is required',
  'lockouts.unlock.reasonMin': 'The reason must have at least 3 characters',
  'lockouts.unlock.note':
    'Unlocking does not change the password: the worker gets their 3 attempts back. If they forgot it, reset it in Users.',
  'lockouts.unlock.confirm': 'Unlock',
  'lockouts.unlock.unlocking': 'Verifying…',
  'lockouts.unlock.error': 'The device could not be unlocked.',
  'lockouts.unlock.signalSent': 'Done: the app of {{nombre}} will unlock within a few seconds.',
  'lockouts.unlock.codeTitle': 'Unlock code',
  'lockouts.unlock.codeIntro': 'Dictate it to {{nombre}}. It is valid until {{hora}}.',
  'lockouts.unlock.codeLabel': '6-digit code',
  'lockouts.unlock.codeOnce': 'This code is shown only once and works for a single unlock. If you lose it, issue another one.',
  'lockouts.unlock.copy': 'Copy code',
  'lockouts.unlock.copied': 'Code copied',
  'profiles.module.bloqueos': 'App lockouts',
  'profiles.action.bloqueos.desbloquear': 'Unlock devices',
  'activityLog.moduleBloqueos': 'App lockouts',
  'mainDashboard.title': 'Route performance',
  'mainDashboard.routeFilter': 'Route filter',
  'mainDashboard.allRoutes': 'All routes',
  'mainDashboard.routesLoadError': 'The routes could not be loaded.',
  'mainDashboard.noRoutesVisible': 'You have no visible routes.',
  'mainDashboard.boxFilter': 'Box filter',
  'mainDashboard.selectBox': 'Select a box',
  'mainDashboard.selectRouteFirst': 'Select a route first',
  'mainDashboard.boxesLoadError': 'The route boxes could not be loaded.',
  'mainDashboard.noBoxes': 'This route has no boxes yet.',
  'mainDashboard.actions': 'More actions',
  'mainDashboard.seeMoreBoxes': 'See more boxes',
  'mainDashboard.openNewBox': 'Open new box',
  'mainDashboard.createExpense': 'Create expense',
  'mainDashboard.createIncome': 'Create income',
  'mainDashboard.actionUnavailable': 'Available once the web endpoint exists to create it on someone else’s box (US-004).',
  'mainDashboard.uploadPortfolio': 'Upload portfolio',
  'mainDashboard.refresh': 'Refresh',
  'mainDashboard.tabsLabel': 'Route performance',
  'mainDashboard.tabSummary': 'Summary',
  'mainDashboard.tabDetails': 'Details',
  'mainDashboard.selectBoxFirst': 'Select a box to see its summary.',
  'mainDashboard.panelCashTitle': 'Final Cash',
  'mainDashboard.entriesGroup': 'Entries',
  'mainDashboard.exitsGroup': 'Exits',
  'mainDashboard.initialCash': 'Initial Cash',
  'mainDashboard.collection': 'Collection',
  'mainDashboard.collectionTooltip': 'Route Collection + Additional Collection',
  'mainDashboard.income': 'Income',
  'mainDashboard.totalSales': 'Total Sales',
  'mainDashboard.expenses': 'Expenses',
  'mainDashboard.withdrawals': 'Withdrawals',
  'mainDashboard.finalCashResult': 'Final Cash',
  'mainDashboard.summaryLoadError': 'The box summary could not be loaded.',
  'mainDashboard.cash': 'Cash',
  'mainDashboard.transfer': 'Electronic transfer',
  'mainDashboard.expandBreakdown': 'See {{label}} breakdown',
  'mainDashboard.collapseBreakdown': 'Hide {{label}} breakdown',
  'mainDashboard.panelPerformanceTitle': 'Performance (Collection)',
  'mainDashboard.expectedCollection': 'Expected',
  'mainDashboard.clientsToCollect': 'Clients to collect from',
  'mainDashboard.additionalCollection': 'Additional Collection',
  'mainDashboard.complianceRate': 'Compliance Rate',
  'mainDashboard.unscheduledClients': 'Unscheduled Clients',

  'mainDashboard.details.loadError': 'The information could not be loaded.',
  'mainDashboard.details.emptyMessage': 'No movements recorded.',
  'mainDashboard.details.columnClient': 'Client',
  'mainDashboard.details.columnPhone': 'Phone',
  'mainDashboard.details.columnFinalValue': 'Final Value',
  'mainDashboard.details.columnPaymentValue': 'Payment Value',
  'mainDashboard.details.columnBalance': 'Balance',
  'mainDashboard.details.columnFrequency': 'Frequency',
  'mainDashboard.details.columnSaleDate': 'Sale Date',
  'mainDashboard.details.columnDays': 'Overdue / Elapsed Days',
  'mainDashboard.details.columnId': 'ID',
  'mainDashboard.details.columnDescription': 'Description',
  'mainDashboard.details.columnComment': 'Comment',
  'mainDashboard.details.columnAmount': 'Amount',
  'mainDashboard.details.columnDate': 'Date',
  'mainDashboard.details.columnImages': 'Images',
  'mainDashboard.details.columnDestination': 'Destination',
  'mainDashboard.details.collectedTitle': 'Collected',
  'mainDashboard.details.unsyncedTitle': 'Unsynced',
  'mainDashboard.details.incomeTitle': 'Income',
  'mainDashboard.details.expensesTitle': 'Expenses',
  'mainDashboard.details.withdrawalsTitle': 'Withdrawals',
  'mainDashboard.details.viewImages': 'View images ({{n}})',
  'mainDashboard.details.imagesTitle': 'Receipts',

  'movementTypes.moduleTitle': 'Movement Types',
  'movementTypes.tabNew': 'Movement Type',
  'movementTypes.tabHistory': 'Movement History',

  'movementTypes.createTitle': 'Create Movement Type',
  'movementTypes.type': 'Movement Type',
  'movementTypes.typeIncome': 'Income',
  'movementTypes.typeExpense': 'Expenses',
  'movementTypes.typeWithdrawal': 'Withdrawals',
  'movementTypes.country': 'Country',
  'movementTypes.countryPlaceholder': 'Select a country',
  'movementTypes.countriesLoadError': 'Countries could not be loaded.',
  'movementTypes.name': 'Name',
  'movementTypes.namePlaceholder': 'E.g.: Motorcycle Gas',
  'movementTypes.observation': 'Observation',
  'movementTypes.observationPlaceholder': 'E.g.: Fuel expense for motorcycles only',
  'movementTypes.observationHelp': 'Optional field.',
  'movementTypes.saving': 'Saving...',
  'movementTypes.created': 'Movement "{{nombre}}" was created.',
  'movementTypes.createError': 'The movement type could not be created.',
  'movementTypes.validation.type': 'Select the movement type.',
  'movementTypes.validation.country': 'Select a country.',
  'movementTypes.validation.name': 'Name is required.',

  'movementTypes.searchPlaceholder': 'Search by observation...',
  'movementTypes.filterCountry': 'Country filter',
  'movementTypes.filterType': 'Type filter',
  'movementTypes.filterStatus': 'Status filter',
  'movementTypes.replicate': 'Replicate to another country',
  'movementTypes.replicateTitle': 'Replicate to another country',
  'movementTypes.replicateSourceCountry': 'Source country',
  'movementTypes.replicateTargetCountry': 'Target country',
  'movementTypes.replicateSelectAll': 'Select all',
  'movementTypes.replicateSelectRow': 'Select {{nombre}}',
  'movementTypes.replicateAlreadyExists': 'Already exists in {{destino}} - will be skipped',
  'movementTypes.replicateSelectedCount': '{{seleccionados}} selected - {{omitidos}} skipped',
  'movementTypes.replicateEmptyHint': 'Choose the source and target country to see the movements to replicate.',
  'movementTypes.replicateNoItems': 'The source country has no movement types to replicate.',
  'movementTypes.replicateLoadError': 'The preview could not be loaded.',
  'movementTypes.replicateAction': 'Replicate',
  'movementTypes.replicateConfirmTitle': 'Confirm replication',
  'movementTypes.replicateConfirmDescription': 'You are about to create {{count}} movement(s) in {{destino}}. Continue?',
  'movementTypes.replicateSuccess': '{{replicados}} replicated, {{omitidos}} skipped.',
  'movementTypes.replicateError': 'The replication could not be completed.',
  'movementTypes.downloadExcel': 'Download Excel',
  'movementTypes.exporting': 'Downloading...',
  'movementTypes.exportError': 'The file could not be downloaded.',
  'movementTypes.listEmpty': 'No movement types registered.',
  'movementTypes.columnCountry': 'Country',
  'movementTypes.columnName': 'Name',
  'movementTypes.columnObservation': 'Observation',
  'movementTypes.columnType': 'Type',
  'movementTypes.columnIncome': 'Income',
  'movementTypes.columnExpense': 'Expenses',
  'movementTypes.columnWithdrawal': 'Withdrawals',
  'movementTypes.columnActions': 'Actions',
  'movementTypes.toggleStatus': 'Change status of {{nombre}}',
  'movementTypes.activateConfirmTitle': 'Activate movement',
  'movementTypes.activateConfirm': 'Activate "{{nombre}}"? It will be available immediately on mobile.',
  'movementTypes.deactivateConfirmTitle': 'Deactivate movement',
  'movementTypes.deactivateConfirm': 'Deactivate "{{nombre}}"? It will stop being available on mobile, but will stay visible in History.',
  'movementTypes.activated': '"{{nombre}}" was activated.',
  'movementTypes.deactivated': '"{{nombre}}" was deactivated.',
  'movementTypes.statusChangeError': 'The movement status could not be changed.'
};

export default en;
